var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "promotion_config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        "hide-required-asterisk": "",
      },
    },
    [
      _c("el-form-item", { staticClass: "tips" }, [
        _vm._v(" 此组件为促销预埋组件，展示样式在个性化菜单内配置 "),
      ]),
      _vm._l(_vm.value.config.value, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "box" },
          [
            _c("div", { staticClass: "item-title" }, [
              _c("span", [_vm._v(" 活动" + _vm._s(index + 1) + " ")]),
              _vm.value.config.value.length > 1
                ? _c("i", {
                    staticClass: "el-icon el-icon-delete",
                    on: {
                      click: function ($event) {
                        return _vm.handleDelUpload(index)
                      },
                    },
                  })
                : _vm._e(),
            ]),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "选择促销菜单",
                  prop: "value." + index + ".category_id",
                  rules: [
                    {
                      required: true,
                      message: "请选择菜单",
                    },
                  ],
                },
              },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      clearable: "",
                      filterable: "",
                      placeholder: "选择菜单",
                    },
                    model: {
                      value: item.category_id,
                      callback: function ($$v) {
                        _vm.$set(item, "category_id", $$v)
                      },
                      expression: "item.category_id",
                    },
                  },
                  _vm._l(_vm.menuListFilter, function (menu, mIndex) {
                    return _c("el-option", {
                      key: mIndex,
                      attrs: { label: menu.show_name, value: menu.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            {
              staticClass: "el-icon-plus add-upload",
              attrs: { type: "primary" },
              on: { click: _vm.addItem },
            },
            [_vm._v(" 添加活动")]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }